import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookingPage from "../pages/booking/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import TestimonialsPage from "../pages/testimonials/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";
import CareersPage from "../pages/careers/page";
import QRPrintPage from "../pages/qr-print/page";
import QRLandingPage from "../pages/qr-landing/page";
import PetsPage from "../pages/pets/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/booking",
    element: <BookingPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/qr",
    element: <QRLandingPage />,
  },
  {
    path: "/qr-print",
    element: <QRPrintPage />,
  },
  {
    path: "/pets",
    element: <PetsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
